import { SvgIcon, SvgIconProps } from "@mui/material";

export const WebPortalIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path fill="transparent" d="M0 0h24v24H0z" />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m14 17 .5 4M10 17l-.5 4M8.143 21h7.714M14 10h5.5M19.5 10A2.5 2.5 0 0 0 22 7.5M14 6a2 2 0 1 0 0 4M17 3a3 3 0 0 0-3 3M19.826 5.033A2.492 2.492 0 0 1 22 7.5M17 3a2.99 2.99 0 0 1 2.826 2.033"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M21 13v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h5"
      />
    </svg>
  </SvgIcon>
);
